// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__-Qqwk","open":"style_open__1rLyA","icon":"style_icon__27fFa"};